import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {InfoBubble, InfoBubbleInstanceProps} from '../../../libs/shared/ui/src/components/tip/infoBubble';
import {InfoBubbleActionInstruction} from '../../../libs/shared/ui/src/components/tip/infoBubbleActionInstruction';
import {InfoBubbleCloseButton} from '../../../libs/shared/ui/src/components/tip/infoBubbleCloseButton';
import {InfoBubbleContent} from '../../../libs/shared/ui/src/components/tip/infoBubbleContent';
import {InfoBubbleTitle} from '../../../libs/shared/ui/src/components/tip/infoBubbleContentTitle';
import {HighlightPulseStylesEnum} from '../../../libs/shared/ui/src/components/tip/infoBubbleHighlight';
import {
  InfoBubblePill,
  InfoBubblePillVariantsEnum,
} from '../../../libs/shared/ui/src/components/tip/infoBubblePill';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {useOnboardingInfoBubblePresenter} from './onboardingInfoBubbleHook';

/*
 * Component.
 */

export const StartGuideCommentComposerInfoBubble: FC<InfoBubbleInstanceProps> = ({anchor}) => {
  const {isVisible, closeInfoBubble: onClose} = useOnboardingInfoBubblePresenter(
    OnboardingTipTypesEnum.START_GUIDE_COMMENT_COMPOSER,
  );

  return (
    <InfoBubble
      position="top"
      anchor={anchor}
      isVisible={isVisible}
      isStandalone
      highlightPulseStyle={HighlightPulseStylesEnum.TIGHT}
      onRequestClose={onClose}
    >
      <InfoBubbleContent>
        <InfoBubblePill type={InfoBubblePillVariantsEnum.EDUCATION} />
        <InfoBubbleTitle>
          <Trans id="infobubble-startguidecommentcomposer-title">@mention a teammate</Trans>
        </InfoBubbleTitle>
        <Trans id="infobubble-startguidecommentcomposer-description">
          Instead of CC or forwarding, you can @mention teammates to collaborate right on the thread.
        </Trans>
        <InfoBubbleActionInstruction
          isAnimated={false}
          iconName="chatFilled"
          text={
            <Trans id="infobubble-startguidecommentcomposer-instruction">
              Type &quot;<strong>@</strong>&quot; in the comment bar, and select a teammate from the list
            </Trans>
          }
        />
        <InfoBubbleCloseButton
          onClose={() => {
            onClose();
          }}
          interactionId="infobubble-startguidecommentcomposer-closebutton"
        />
      </InfoBubbleContent>
    </InfoBubble>
  );
};
